import { defineMessages } from 'react-intl';

export default defineMessages({
  adults: {
    id: 'filtersModal.guests.adults',
    defaultMessage: 'Adults',
  },
  children: {
    id: 'filtersModal.guests.children',
    defaultMessage: 'Children',
  },
  infants: {
    id: 'filtersModal.guests.infants',
    defaultMessage: 'Infants',
  },
});
